// extracted by mini-css-extract-plugin
export var colorSquare = "_o9-0";
export var danger = "_o9-5";
export var lightPink = "_o9-8";
export var neutralBlue = "_o9-7";
export var neutralYellow = "_o9-6";
export var normal = "_o9-1";
export var primary = "_o9-2";
export var primaryLight = "_o9-3";
export var solidBlack = "_o9-g";
export var solidGreen = "_o9-b";
export var solidLightBlue = "_o9-d";
export var solidNavy = "_o9-c";
export var solidOrange = "_o9-f";
export var solidPink = "_o9-e";
export var solidRed = "_o9-9";
export var solidYellow = "_o9-a";
export var success = "_o9-4";